import React from 'react';
import { Paper, Tab, Tabs } from '@mui/material';

function BuilderCategoryTabs({ activeTab, onChange, tabs }) {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Tabs
        value={activeTab}
        onChange={(event, value) => onChange(value)}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab) => (
          <Tab key={tab.key} icon={tab.icon} iconPosition="start" label={tab.label} />
        ))}
      </Tabs>
    </Paper>
  );
}

export default BuilderCategoryTabs;
